import { z } from 'zod';
import { c } from '../../contract';

const bookCoverProgressIndicatorSchema = z.object({
  currentBook: z.number(),
  totalBooks: z.number(),
  bookCompletionPercent: z.number(),
  nextRelease: z.string().nullable(),
});

export type BookCoverProgressIndicator = z.infer<typeof bookCoverProgressIndicatorSchema>;

export const bookCoverProgressIndicatorsRouter = c.router(
  {
    createOrUpdate: {
      summary: 'Create or update the book cover progress indicator for a series (migrated from Jupiter, DEV-4476)',
      method: 'POST',
      path: '/create-or-update',
      body: z.object({
        seriesId: z.string(),
        currentBook: z.number(),
        totalBooks: z.number(),
        bookCompletionPercent: z.number(),
        nextRelease: z.string().nullable().optional(),
      }),
      responses: {
        200: z.object({ success: z.literal(true) }),
      },
    },
    getList: {
      summary:
        'Get all book cover progress indicators for the authenticated user, keyed by seriesId (migrated from Jupiter, DEV-4476)',
      method: 'GET',
      path: '/get-list',
      responses: {
        200: z.record(z.string(), bookCoverProgressIndicatorSchema),
      },
    },
  },
  {
    pathPrefix: '/book-cover-progress-indicators',
  },
);
